
import Hero from "../components/Hero";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Trip from "../components/Trip";
import AboutImg from "../assets/night.jpg";

function Service(params) {
  return (
    <>
     <Navbar />
      <Hero
        cName="hero-mid"
        heroImg={AboutImg}
        title="Service"
        url="/service"
        
        btnClass="hide"
      />
      <Trip/>
      <Footer/>
    </>
  );
}

export default Service;
